import _default from './Feed';
export { _default as default };